/**
 * Public barrel export for the InlineFilterPanel component
 * @module components/shared/search-modal/InlineFilterPanel
 */

export { default } from "./InlineFilterPanelContainer";
